import { ADD_AREA_SUCCESS, DELETE_AREA_SUCCESS, GET_AREAS_LIST_SUCCESS, MODAL_AREA_SHOW, UPDATE_AREA_SUCCESS } from "./actions";

const INIT_STATE = {
    areas: [],
    error: {},
    totalItems:0,
    areaModalShow:false
};


const AreaReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_AREAS_LIST_SUCCESS:
            return {
                ...state,
                areas: action.payload.data.data,
                totalItems: action.payload.data.total,
            };
        case ADD_AREA_SUCCESS:
            return {
                  ...state,
                  areas: action.payload.data.data,
                    totalItems: action.payload.data.total,
                };
        case UPDATE_AREA_SUCCESS:
            return {
                    ...state,
                    areas: action.payload
                };
        case DELETE_AREA_SUCCESS:
            return {
                    ...state,
                    areas: action.payload
                }
        case MODAL_AREA_SHOW:
            return {
                        ...state,
                        areaModalShow: action.payload,
                    }   
        default:
            return state;
    }
};

export default AreaReducer;